<template>
  <div class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center" style="z-index:999999;">
    <div class="fixed inset-0 transition-opacity" @click="$emit('close')">
      <div class="absolute inset-0 bg-black opacity-75"></div>
    </div>
    <div class="bg-white shadow-xl transform transition-all sm:max-w-128 sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-4 sm:pb-4">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" class="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150" aria-label="Close" @click="$emit('close')">
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="sm:flex sm:items-start border-b border-gray-400">
          <div class="mt-3 text-center sm:mt-0 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-black pb-2" id="modal-headline">
              {{ heading }}
            </h3>
          </div>
        </div>
        <div class="mt-4 text-sm">
          <slot/>
        </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
        <slot name="actions"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendPaymentModal',
  props: {
    heading: { default: 'Send Payment' },
  },
  mounted() {
    document.body.classList.add('overflow-hidden')
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden')
  }
}
</script>
